import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { translateSiteText as txt } from "../i18n";
import { metadataFor } from "../data/metadata";

export function PageEffects() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const initial = useRef(true);
  useEffect(() => {
    const meta = metadataFor(location.pathname);
    document.title = `${meta.title.split(" — ").map(txt).join(" — ")} | Systein`;
    const setMeta = (key: string, value: string, property = false) => {
      const attribute = property ? "property" : "name";
      let element = document.querySelector<HTMLMetaElement>(
        `meta[${attribute}="${key}"]`,
      );
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
      }
      element.content = value;
    };
    setMeta("description", txt(meta.description));
    setMeta("robots", meta.noindex ? "noindex, follow" : "index, follow");
    setMeta("og:title", document.title, true);
    setMeta("og:description", txt(meta.description), true);
    setMeta(
      "og:locale",
      i18n.language.startsWith("nl") ? "nl_NL" : "en_GB",
      true,
    );
    setMeta("og:url", `https://systein.nl${meta.path}`, true);
    setMeta("twitter:title", document.title);
    setMeta("twitter:description", txt(meta.description));
    let canonical = document.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://systein.nl${meta.path}`;
  }, [location.pathname, i18n.language]);
  useEffect(() => {
    document.documentElement.lang = i18n.language.split("-")[0];
  }, [i18n.language]);
  useEffect(() => {
    let frame = 0;
    let attempts = 0;
    const navigate = () => {
      const id = location.hash.slice(1);
      const element = id
        ? document.getElementById(id)
        : document.querySelector<HTMLElement>("main h1");
      if ((!element || !element.getClientRects().length) && attempts++ < 120) {
        frame = requestAnimationFrame(navigate);
        return;
      }
      if (id && element)
        element.scrollIntoView({ behavior: "auto", block: "start" });
      else window.scrollTo({ top: 0, behavior: "auto" });
      if (!initial.current && element) {
        element.setAttribute("tabindex", "-1");
        element.focus({ preventScroll: true });
      }
      initial.current = false;
    };
    frame = requestAnimationFrame(navigate);
    return () => cancelAnimationFrame(frame);
  }, [location.pathname, location.hash]);
  return null;
}
